import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/lib/logger';

// Liste des user agents connus de bots
const BOT_PATTERNS = [
  /bot/i,
  /crawler/i,
  /spider/i,
  /slurp/i,
  /mediapartners/i,
  /googlebot/i,
  /bingbot/i,
  /yandex/i,
  /baiduspider/i,
  /duckduckbot/i,
  /facebookexternalhit/i,
  /linkedinbot/i,
  /twitterbot/i,
  /whatsapp/i,
  /telegrambot/i,
];

const isBot = (): boolean => {
  const userAgent = navigator.userAgent;
  return BOT_PATTERNS.some(pattern => pattern.test(userAgent));
};

export function AnalyticsTracker() {
  useEffect(() => {
    const trackPageView = async () => {
      try {
        const currentPath = window.location.pathname;
        const userAgent = navigator.userAgent;
        const isBotVisit = isBot();
        
        // Générer un session_id basé sur le fingerprint du navigateur
        const sessionId = sessionStorage.getItem('analytics_session_id') || 
          `session_${Date.now()}_${Math.random().toString(36).substring(7)}`;
        
        if (!sessionStorage.getItem('analytics_session_id')) {
          sessionStorage.setItem('analytics_session_id', sessionId);
        }

        // Enregistrer la visite
        await supabase.from('site_analytics').insert({
          page_url: currentPath,
          user_agent: userAgent,
          is_bot: isBotVisit,
          session_id: sessionId,
        });
      } catch (error) {
        // Silent fail - ne pas perturber l'expérience utilisateur
        logger.debug('Analytics tracking error:', error);
      }
    };

    // Tracker la page actuelle
    trackPageView();

    // Tracker les changements de page (pour les SPAs)
    const handleRouteChange = () => {
      trackPageView();
    };

    // Écouter les changements d'URL
    window.addEventListener('popstate', handleRouteChange);
    
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  return null; // Ce composant n'affiche rien
}
